export var PasswordResetIA = function PasswordResetIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return RESET_PASSWORD(strictLocalize);
    },
    getDescription: function getDescription() {
      return [IF_YOU_WOULD_LIKE_TO_RESET_YOUR_PASSWORD(strictLocalize), FIRST_STEP_TO_RESET_PASSWORD(strictLocalize), SECOND_STEP_TO_RESET_PASSWORD(strictLocalize), THIRD_STEP_TO_RESET_PASSWORD(strictLocalize), THIS_WILL_SEND_AN_AUTOMATED_EMAIL(strictLocalize)];
    }
  };
};
var RESET_PASSWORD = function RESET_PASSWORD(strictLocalize) {
  return strictLocalize({
    id: "8BAYrT",
    defaultMessage: [{
      "type": 0,
      "value": "Réinitialisation du mot de passe"
    }]
  });
};
var IF_YOU_WOULD_LIKE_TO_RESET_YOUR_PASSWORD = function IF_YOU_WOULD_LIKE_TO_RESET_YOUR_PASSWORD(strictLocalize) {
  return strictLocalize({
    id: "uaYTsO",
    defaultMessage: [{
      "type": 0,
      "value": "Si vous souhaitez réinitialiser votre mot de passe, veuillez suivre les étapes suivantes :"
    }]
  });
};
var FIRST_STEP_TO_RESET_PASSWORD = function FIRST_STEP_TO_RESET_PASSWORD(strictLocalize) {
  return strictLocalize({
    id: "FCoWDD",
    defaultMessage: [{
      "type": 0,
      "value": "1. Cliquez sur le bouton « Se connecter » en haut à droite de la page d'accueil."
    }]
  });
};
var SECOND_STEP_TO_RESET_PASSWORD = function SECOND_STEP_TO_RESET_PASSWORD(strictLocalize) {
  return strictLocalize({
    id: "jmoi8G",
    defaultMessage: [{
      "type": 0,
      "value": "2. Saisissez votre adresse e-mail de connexion et appuyez sur Entrée."
    }]
  });
};
var THIRD_STEP_TO_RESET_PASSWORD = function THIRD_STEP_TO_RESET_PASSWORD(strictLocalize) {
  return strictLocalize({
    id: "fMuh5K",
    defaultMessage: [{
      "type": 0,
      "value": "3. Sur l'écran suivant, cliquez sur le lien indiquant « Mot de passe oublié ? Réinitialiser »."
    }]
  });
};
var THIS_WILL_SEND_AN_AUTOMATED_EMAIL = function THIS_WILL_SEND_AN_AUTOMATED_EMAIL(strictLocalize) {
  return strictLocalize({
    id: "NWeLC2",
    defaultMessage: [{
      "type": 0,
      "value": "Un e-mail sera envoyé automatiquement à l'adresse e-mail de votre compte pour vous aider à réinitialiser votre mot de passe. Si vous ne recevez pas l'e-mail, vérifiez que vous avez correctement orthographié votre adresse e-mail et consultez votre dossier de courrier indésirable. En cas de problème, contactez-nous à l'aide des options ci-dessous."
    }]
  });
};